import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import KonfiguracjaService from "./KonfiguracjaService";
import KonfiguracjaTable from "./components/KonfiguracjaTable";

export default class KonfiguracjaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            konfig:[]
        };
        this.onChangeWartosc = this.onChangeWartosc.bind(this)
    }

    componentDidMount() {
        this.getKonfig()
    }

    getKonfig(){
        KonfiguracjaService.getPelenKonfig().then(function (response) {
            this.setState({konfig:response.data.content})
        }.bind(this))
    }

    onChangeWartosc(obj){
        KonfiguracjaService.ustawWartosc(obj.id,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie edytowano wartość", "", 3000);
                this.getKonfig();
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycji wartości ", "", 3000);
            }
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <ReactNotify ref='notificator'/>
                <Grid fluid={true} id={'AdministracjaContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/konfiguracja',
                                    text: 'Konfiguracja'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                          <KonfiguracjaTable data={this.state.konfig} handleClickZapisz={this.onChangeWartosc}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/konfiguracja/KonfiguracjaContainer.js